import getConfig from 'next/config';

export default function checkIfSuperAdmin(accountId) {
  const { adminId } = getConfig().publicRuntimeConfig;
  return adminId === accountId;
}
